import { useState, useEffect } from "react";
import { supabase } from "./supabase";

const ADMIN_EMAIL = "admin@iosono.com";
const ADMIN_PASS  = "IoSono2024Admin!";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap');
  @import url('https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@2.44.0/tabler-icons.min.css');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg:#0a0a0a; --bg1:#111; --bg2:#1a1a1a; --border:#2a2a2a; --border2:#222;
    --text:#f0eeff; --text2:#888; --text3:#555;
    --purple:#7c3aed; --purple-lt:#a78bfa; --purple-bg:#1a1228;
    --green:#4ade80; --green-bg:#0d2112;
    --amber:#fbbf24; --amber-bg:#1a1208;
    --red:#f87171; --red-bg:#1a0808;
    --blue:#60a5fa; --blue-bg:#0d1a2e;
    --radius:12px; --radius-sm:8px; --radius-lg:16px;
    --font-display:'Playfair Display',serif; --font-body:'DM Sans',sans-serif;
  }
  body { font-family:var(--font-body); background:var(--bg); color:var(--text); min-height:100vh; }
  .app { max-width:680px; margin:0 auto; padding:0 16px 80px; }
  .nav { position:fixed; bottom:0; left:0; right:0; background:rgba(10,10,10,0.95); backdrop-filter:blur(12px); border-top:0.5px solid var(--border); display:flex; justify-content:center; z-index:100; }
  .nav-item { flex:1; max-width:80px; display:flex; flex-direction:column; align-items:center; gap:3px; padding:10px 0 14px; cursor:pointer; color:var(--text3); font-size:10px; letter-spacing:0.05em; text-transform:uppercase; border:none; background:transparent; }
  .nav-item.active { color:var(--purple-lt); }
  .nav-item i { font-size:20px; }
  .card { background:var(--bg1); border:0.5px solid var(--border); border-radius:var(--radius-lg); padding:20px; margin-bottom:12px; }
  .card-title { font-size:10px; letter-spacing:0.14em; text-transform:uppercase; color:var(--text2); margin-bottom:14px; }
  .hero { background:var(--bg); border-radius:var(--radius-lg); padding:28px 20px; margin-bottom:12px; position:relative; overflow:hidden; }
  .hero::before { content:''; position:absolute; inset:0; background:radial-gradient(ellipse 80% 60% at 50% 0%,#2a1a4a 0%,transparent 70%); pointer-events:none; }
  .hero-inner { position:relative; }
  .pill { font-size:11px; padding:4px 12px; border-radius:100px; display:inline-block; }
  .pill-purple { background:var(--purple-bg); color:var(--purple-lt); }
  .pill-green  { background:var(--green-bg);  color:var(--green); }
  .pill-amber  { background:var(--amber-bg);  color:var(--amber); }
  .pill-red    { background:var(--red-bg);    color:var(--red); }
  .pill-gray   { background:var(--bg2);       color:var(--text2); }
  .btn { border:none; border-radius:100px; font-family:var(--font-body); font-size:14px; font-weight:500; cursor:pointer; padding:12px 24px; }
  .btn-primary { background:var(--purple); color:#fff; }
  .btn-outline { background:transparent; border:1px solid #3d2d6e; color:var(--purple-lt); }
  .btn-green { background:var(--green-bg); border:1px solid rgba(74,222,128,0.3); color:var(--green); }
  .btn-red { background:var(--red-bg); border:1px solid rgba(226,75,74,0.3); color:var(--red); }
  .btn-full { width:100%; border-radius:var(--radius); padding:13px; font-size:15px; }
  .btn-sm { padding:6px 14px; font-size:12px; border-radius:var(--radius-sm); }
  .field { margin-bottom:14px; }
  .field label { display:block; font-size:12px; color:var(--text2); margin-bottom:5px; }
  .field input,.field textarea,.field select { width:100%; background:var(--bg2); border:0.5px solid var(--border); border-radius:var(--radius-sm); padding:11px 14px; font-size:14px; color:var(--text); font-family:var(--font-body); }
  .field input:focus,.field textarea:focus,.field select:focus { outline:none; border-color:var(--purple); }
  .field textarea { resize:vertical; min-height:80px; line-height:1.5; }
  .field-row { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
  .grid-2 { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
  .grid-4 { display:grid; grid-template-columns:repeat(4,1fr); gap:10px; }
  .divider { height:0.5px; background:var(--border); margin:14px 0; }
  .divider-text { display:flex; align-items:center; gap:10px; margin:14px 0; }
  .divider-text::before,.divider-text::after { content:''; flex:1; height:0.5px; background:var(--border); }
  .divider-text span { font-size:12px; color:var(--text2); }
  .avatar { border-radius:50%; display:flex; align-items:center; justify-content:center; font-weight:500; flex-shrink:0; }
  .avatar-lg { width:64px; height:64px; font-size:22px; }
  .avatar-md { width:42px; height:42px; font-size:15px; }
  .avatar-sm { width:30px; height:30px; font-size:11px; }
  .toggle-bar { display:flex; background:var(--bg2); border-radius:var(--radius); padding:4px; gap:4px; margin-bottom:16px; }
  .toggle-btn { flex:1; padding:8px; border-radius:var(--radius-sm); border:none; background:transparent; font-size:12px; color:var(--text2); cursor:pointer; font-family:var(--font-body); display:flex; align-items:center; justify-content:center; gap:5px; }
  .toggle-btn.active { background:var(--bg1); color:var(--text); border:0.5px solid var(--border); font-weight:500; }
  .toggle-btn i { font-size:14px; }
  .timeline { padding-left:22px; position:relative; }
  .timeline::before { content:''; position:absolute; left:6px; top:8px; bottom:8px; width:1px; background:var(--border); }
  .tl-item { position:relative; margin-bottom:16px; }
  .tl-dot { position:absolute; left:-18px; top:4px; width:9px; height:9px; border-radius:50%; border:2px solid var(--bg1); }
  .tl-dot.done { background:var(--green); }
  .tl-dot.active { background:var(--purple-lt); }
  .tl-dot.pending { background:var(--border); }
  .tl-time { font-size:11px; color:var(--text2); margin-bottom:2px; }
  .tl-title { font-size:13px; font-weight:500; margin-bottom:2px; }
  .tl-desc { font-size:12px; color:var(--text2); line-height:1.5; }
  .row-item { display:flex; align-items:center; gap:12px; padding:10px 0; border-bottom:0.5px solid var(--border); }
  .row-item:last-child { border-bottom:none; }
  .row-info { flex:1; }
  .row-name { font-size:13px; font-weight:500; margin-bottom:2px; }
  .row-sub { font-size:12px; color:var(--text2); }
  .row-right { text-align:right; flex-shrink:0; }
  .row-amount { font-size:13px; font-weight:500; }
  .service-opt { background:var(--bg2); border:0.5px solid var(--border); border-radius:var(--radius); padding:10px 12px; cursor:pointer; display:flex; justify-content:space-between; align-items:center; }
  .service-opt.selected { border:1.5px solid var(--purple); background:rgba(124,58,237,0.08); }
  .tag { display:inline-flex; align-items:center; gap:5px; background:var(--bg2); border:0.5px solid var(--border); border-radius:100px; padding:5px 13px; font-size:12px; color:var(--text2); cursor:pointer; }
  .tag.on { background:rgba(124,58,237,0.15); border-color:rgba(124,58,237,0.5); color:var(--purple-lt); }
  .tag.danger.on { background:rgba(226,75,74,0.15); border-color:rgba(226,75,74,0.3); color:var(--red); }
  .tags-wrap { display:flex; flex-wrap:wrap; gap:6px; margin-bottom:12px; }
  .stats-row { display:grid; grid-template-columns:repeat(4,1fr); gap:1px; background:var(--border); border-radius:var(--radius-sm); overflow:hidden; }
  .stat-cell { background:var(--bg1); padding:12px 8px; text-align:center; }
  .stat-num { font-size:16px; font-weight:500; }
  .stat-lbl { font-size:10px; color:var(--text2); margin-top:2px; text-transform:uppercase; letter-spacing:0.05em; }
  .port-card { background:var(--bg2); border-radius:var(--radius); overflow:hidden; cursor:pointer; border:0.5px solid var(--border); }
  .port-thumb { aspect-ratio:1; display:flex; align-items:center; justify-content:center; font-size:28px; position:relative; }
  .port-badge { position:absolute; top:6px; left:6px; font-size:10px; background:rgba(0,0,0,0.7); color:#fff; padding:2px 8px; border-radius:100px; }
  .port-brand { position:absolute; top:6px; right:6px; font-size:10px; background:rgba(124,58,237,0.85); color:#fff; padding:2px 8px; border-radius:100px; }
  .port-metrics { padding:8px; display:grid; grid-template-columns:repeat(4,1fr); gap:2px; }
  .port-metric { text-align:center; }
  .port-metric-num { font-size:11px; font-weight:500; }
  .port-metric-lbl { font-size:9px; color:var(--text2); }
  .inf-card { background:var(--bg1); border:0.5px solid var(--border); border-radius:var(--radius-lg); padding:16px; cursor:pointer; }
  .inf-card:hover { border-color:var(--purple); }
  .escrow-note { display:flex; gap:8px; align-items:flex-start; background:var(--green-bg); border-radius:var(--radius-sm); padding:10px 12px; margin-top:10px; }
  .escrow-note i { color:var(--green); font-size:16px; flex-shrink:0; margin-top:1px; }
  .escrow-note span { font-size:12px; color:#86efac; line-height:1.5; }
  .bar-chart { display:flex; align-items:flex-end; gap:5px; height:70px; }
  .bar-col { flex:1; display:flex; flex-direction:column; align-items:center; gap:3px; height:100%; justify-content:flex-end; }
  .bar-col-fill { width:100%; background:var(--purple); border-radius:3px 3px 0 0; }
  .bar-col-lbl { font-size:9px; color:var(--text2); }
  .notif-item { display:flex; gap:10px; align-items:flex-start; padding:10px 0; border-bottom:0.5px solid var(--border); }
  .notif-item:last-child { border-bottom:none; }
  .notif-dot { width:8px; height:8px; border-radius:50%; flex-shrink:0; margin-top:5px; }
  .countdown-box { background:var(--purple-bg); border-radius:var(--radius); padding:12px 16px; display:flex; justify-content:space-between; align-items:center; margin-bottom:12px; }
  .countdown-time { font-size:24px; font-weight:500; color:var(--purple-lt); }
  .progress-steps { display:flex; align-items:center; justify-content:center; gap:0; margin-bottom:24px; }
  .prog-step { display:flex; flex-direction:column; align-items:center; gap:4px; }
  .prog-circle { width:30px; height:30px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:12px; font-weight:500; border:1.5px solid var(--border); color:var(--text2); background:var(--bg1); }
  .prog-circle.active { background:var(--purple); color:#fff; border-color:var(--purple); }
  .prog-circle.done { background:var(--green-bg); color:var(--green); border-color:var(--green); }
  .prog-label { font-size:10px; color:var(--text2); white-space:nowrap; }
  .prog-label.active { color:var(--purple-lt); }
  .prog-line { width:40px; height:1px; background:var(--border); margin-bottom:16px; }
  .prog-line.done { background:var(--green); }
  table { width:100%; border-collapse:collapse; font-size:13px; }
  th { text-align:left; font-size:10px; color:var(--text2); font-weight:400; padding:6px 0; border-bottom:0.5px solid var(--border); letter-spacing:0.06em; text-transform:uppercase; }
  td { padding:10px 0; border-bottom:0.5px solid var(--border); color:var(--text); vertical-align:middle; }
  tr:last-child td { border-bottom:none; }
  ::-webkit-scrollbar { width:4px; }
  ::-webkit-scrollbar-thumb { background:var(--border); border-radius:2px; }
`;

const NICHES = ['Moda y estilo','Gastronomía','Fitness y salud','Viajes','Tecnología','Belleza y skincare','Humor','Deporte','Maternidad','Mascotas','Bebidas'];
const ZONES = [
  'CABA','GBA Norte','GBA Sur','GBA Oeste',
  'Buenos Aires (interior)','Catamarca','Chaco','Chubut','Córdoba','Corrientes',
  'Entre Ríos','Formosa','Jujuy','La Pampa','La Rioja','Mendoza','Misiones',
  'Neuquén','Río Negro','Salta','San Juan','San Luis','Santa Cruz','Santa Fe',
  'Santiago del Estero','Tierra del Fuego','Tucumán'
];
const SERVICES_LIST = ['Historia','Publicación','Mención','Reel','Live','Review'];

const INFLUENCERS = [
  { id:1, initials:'VL', name:'Vale López', handle:'@valelopez', niche:'Moda y estilo', followers:'28K', zone:'CABA', eng:'4.8%', campaigns:12, rating:4.9, color:'#2a1a4a', textColor:'#a78bfa',
    services:[{name:'Historia',price:'USD 35',icon:'ti-clock'},{name:'Publicación',price:'USD 80',icon:'ti-photo'},{name:'Reel',price:'USD 120',icon:'ti-player-play'},{name:'Review',price:'USD 95',icon:'ti-star'}],
    portfolio:[{emoji:'👗',brand:'Tienda Nómade',type:'Reel',reach:'48.2K',likes:'3.1K',comments:'284',eng:'6.4%'},{emoji:'👠',brand:'Studio Luce',type:'Post',reach:'22.7K',likes:'1.8K',comments:'156',eng:'5.1%'},{emoji:'✨',brand:'Marca Savia',type:'Historia',reach:'12.4K',likes:'890',comments:'43',eng:'7.2%'}]},
  { id:2, initials:'MG', name:'Maxi González', handle:'@maxifit', niche:'Fitness y salud', followers:'61K', zone:'Córdoba', eng:'5.2%', campaigns:8, rating:4.7, color:'#0d2112', textColor:'#4ade80',
    services:[{name:'Historia',price:'$45.000',icon:'ti-clock'},{name:'Reel',price:'$150.000',icon:'ti-player-play'},{name:'Live',price:'$200.000',icon:'ti-live-photo'}],
    portfolio:[{emoji:'💪',brand:'Gym Pro',type:'Reel',reach:'55K',likes:'4.2K',comments:'380',eng:'7.8%'},{emoji:'🥗',brand:'NutriBar',type:'Post',reach:'30K',likes:'2.1K',comments:'190',eng:'6.2%'},{emoji:'🏃',brand:'RunBA',type:'Historia',reach:'18K',likes:'1.2K',comments:'95',eng:'5.5%'}]},
  { id:3, initials:'SR', name:'Sofi Ríos', handle:'@sofibeauty', niche:'Belleza y skincare', followers:'9.2K', zone:'Rosario', eng:'6.1%', campaigns:3, rating:4.5, color:'#1a0d14', textColor:'#f472b6',
    services:[{name:'Historia',price:'USD 18',icon:'ti-clock'},{name:'Review',price:'USD 55',icon:'ti-star'},{name:'Mención',price:'USD 12',icon:'ti-at'}],
    portfolio:[{emoji:'💄',brand:'Glam BA',type:'Post',reach:'8K',likes:'620',comments:'78',eng:'6.8%'},{emoji:'🧴',brand:'Savia Skin',type:'Review',reach:'6K',likes:'480',comments:'55',eng:'6.2%'},{emoji:'💅',brand:'NailCo',type:'Historia',reach:'4K',likes:'310',comments:'32',eng:'5.9%'}]}
];

const AvatarEl = ({ initials, color, textColor, size='md' }) => (
  <div className={`avatar avatar-${size}`} style={{ background:color, color:textColor }}>{initials}</div>
);

// ─── LANDING PÚBLICA ──────────────────────────────────────────────────────────
function Landing({ onNav }) {
  return (
    <div>
      <div className="hero" style={{ textAlign:'center', paddingTop:48, paddingBottom:48 }}>
        <div className="hero-inner">
          <div style={{ fontFamily:'var(--font-display)', fontSize:48, fontWeight:600, color:'var(--text)', letterSpacing:'0.06em', marginBottom:10 }}>
            <span style={{ color:'var(--purple-lt)', fontStyle:'italic' }}>Io</span> Sono
          </div>
          <div style={{ fontSize:12, color:'var(--text2)', letterSpacing:'0.18em', textTransform:'uppercase', marginBottom:24 }}>
            marketplace de influencers argentinos
          </div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:36, fontWeight:600, lineHeight:1.2, marginBottom:14 }}>
            Tu marca,<br/>su voz. <span style={{ fontStyle:'italic', color:'var(--purple-lt)' }}>Conectados.</span>
          </div>
          <div style={{ fontSize:15, color:'var(--text2)', maxWidth:380, margin:'0 auto 32px', lineHeight:1.6 }}>
            Encontrá el influencer ideal. Pagá seguro. Recibí resultados.
          </div>
          <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap', marginBottom:28 }}>
            <button className="btn btn-primary" onClick={() => onNav('register', { initialRole: 'influencer' })}>Soy influencer ↗</button>
            <button className="btn btn-outline" onClick={() => onNav('register', { initialRole: 'marca' })}>Soy marca ↗</button>
          </div>
          <div className="tags-wrap" style={{ justifyContent:'center' }}>
            {NICHES.slice(0,6).map(n => <span key={n} className="tag">{n}</span>)}
            <span className="tag">+5 más</span>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-title">¿Cómo funciona?</div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:1, background:'var(--border)', borderRadius:'var(--radius-sm)', overflow:'hidden' }}>
          {[['1','Creá tu cuenta','Marca o influencer, gratis'],['2','Elegí y contratá','Encontrá al influencer ideal'],['3','Pago seguro','El dinero queda retenido'],['4','Confirmar y cobrar','Solo cuando se cumplió']].map(([n,t,d]) => (
            <div key={n} style={{ background:'var(--bg1)', padding:'14px 10px', textAlign:'center' }}>
              <div style={{ width:28,height:28,borderRadius:'50%',background:'var(--purple-bg)',color:'var(--purple-lt)',fontSize:13,fontWeight:500,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 8px' }}>{n}</div>
              <div style={{ fontSize:12,fontWeight:500,marginBottom:3 }}>{t}</div>
              <div style={{ fontSize:11,color:'var(--text2)',lineHeight:1.4 }}>{d}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display:'flex', gap:10, marginBottom:12 }}>
        <button className="btn btn-primary btn-full" onClick={() => onNav('register')}>Crear cuenta gratis ↗</button>
        <button className="btn btn-outline btn-full" onClick={() => onNav('login')}>Ya tengo cuenta</button>
      </div>

      <div style={{ textAlign:'center', fontSize:12, color:'var(--text2)', paddingBottom:8 }}>
        +1.200 influencers verificados · Pago 100% seguro con escrow
      </div>
    </div>
  );
}

// ─── LOGIN ────────────────────────────────────────────────────────────────────
function Login({ onNav, onLogin }) {
  const [role, setRole] = useState('marca');
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);

  const handleForgot = async () => {
    if (!forgotEmail) { return; }
    setForgotLoading(true);
    await supabase.auth.resetPasswordForEmail(forgotEmail, {
      redirectTo: 'https://iosonoinfluencer.com.ar/reset-password',
    });
    setForgotLoading(false);
    setForgotSent(true);
  };

  if (showForgot) {
    return (
      <div style={{ maxWidth:400, margin:'0 auto' }}>
        <div className="hero" style={{ textAlign:'center', marginBottom:16 }}>
          <div className="hero-inner">
            <div style={{ fontFamily:'var(--font-display)', fontSize:32, color:'var(--text)', letterSpacing:'0.1em', marginBottom:4 }}>
              <span style={{ color:'var(--purple-lt)', fontStyle:'italic' }}>Io</span> Sono
            </div>
          </div>
        </div>
        <div className="card">
          {!forgotSent ? (
            <>
              <div style={{ fontSize:18,fontWeight:500,marginBottom:6 }}>Recuperar contraseña</div>
              <div style={{ fontSize:13,color:'var(--text2)',marginBottom:18,lineHeight:1.6 }}>
                Ingresá tu email y te mandamos un link para crear una nueva contraseña.
              </div>
              <div className="field">
                <label>Email de tu cuenta</label>
                <input type="email" placeholder="hola@vos.com" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} onKeyDown={e => e.key==='Enter' && handleForgot()} />
              </div>
              <button className="btn btn-primary btn-full" onClick={handleForgot} disabled={forgotLoading}>
                {forgotLoading ? 'Enviando...' : 'Enviar link de recuperación →'}
              </button>
              <button className="btn btn-outline btn-full" style={{ marginTop:8 }} onClick={() => setShowForgot(false)}>
                ← Volver al login
              </button>
            </>
          ) : (
            <div style={{ textAlign:'center', padding:'1rem 0' }}>
              <div style={{ width:56,height:56,borderRadius:'50%',background:'var(--green-bg)',color:'var(--green)',fontSize:24,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 1rem' }}>
                <i className="ti ti-mail-check" />
              </div>
              <div style={{ fontSize:17,fontWeight:500,marginBottom:8 }}>¡Email enviado!</div>
              <div style={{ fontSize:13,color:'var(--text2)',lineHeight:1.6,marginBottom:6 }}>Mandamos el link de recuperación a:</div>
              <div style={{ fontSize:14,fontWeight:500,color:'var(--purple-lt)',marginBottom:20 }}>{forgotEmail}</div>
              <div style={{ fontSize:12,color:'var(--text2)',lineHeight:1.6,marginBottom:20 }}>
                Revisá tu correo (y la carpeta de spam). El link expira en 1 hora.
              </div>
              <button className="btn btn-outline btn-full" onClick={() => { setShowForgot(false); setForgotSent(false); }}>
                ← Volver al login
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  const handleLogin = async () => {
    if (!email || !pass) { setError('Completá email y contraseña.'); return; }
    if (email === ADMIN_EMAIL && pass === ADMIN_PASS) { onLogin({ role:'admin', email }); return; }

    setError('');
    setLoading(true);
    const { data, error: authError } = await supabase.auth.signInWithPassword({ email, password: pass });
    setLoading(false);

    if (authError) {
      setError('Email o contraseña incorrectos.');
      return;
    }

    const userId = data.user.id;
    const { data: perfil } = await supabase.from('usuarios').select('*').eq('id', userId).single();

    if (!perfil) {
      setError('No encontramos tu perfil. Probá registrarte de nuevo.');
      return;
    }

    onLogin({ id: userId, role: perfil.rol, email: perfil.email, name: perfil.nombre });
  };

  return (
    <div style={{ maxWidth:400, margin:'0 auto' }}>
      <div className="hero" style={{ textAlign:'center', marginBottom:16 }}>
        <div className="hero-inner">
          <div style={{ fontFamily:'var(--font-display)', fontSize:32, color:'var(--text)', letterSpacing:'0.1em', marginBottom:4 }}>
            <span style={{ color:'var(--purple-lt)', fontStyle:'italic' }}>Io</span> Sono
          </div>
          <div style={{ fontSize:11, color:'var(--text2)', letterSpacing:'0.14em', textTransform:'uppercase' }}>el marketplace de influencers argentinos</div>
        </div>
      </div>
      <div className="card">
        <div className="toggle-bar">
          <button className={`toggle-btn ${role==='marca'?'active':''}`} onClick={() => setRole('marca')}><i className="ti ti-building-store" /> Soy marca</button>
          <button className={`toggle-btn ${role==='influencer'?'active':''}`} onClick={() => setRole('influencer')}><i className="ti ti-camera" /> Soy influencer</button>
        </div>
        {error && <div style={{ background:'var(--red-bg)',border:'0.5px solid rgba(226,75,74,0.3)',borderRadius:'var(--radius-sm)',padding:'10px 14px',fontSize:13,color:'var(--red)',marginBottom:14,display:'flex',gap:8,alignItems:'center' }}><i className="ti ti-alert-circle" /> {error}</div>}
        <div className="field"><label>Email</label><input type="email" placeholder="hola@vos.com" value={email} onChange={e => setEmail(e.target.value)} /></div>
        <div className="field" style={{ marginBottom:6 }}>
          <label>Contraseña</label>
          <div style={{ position:'relative' }}>
            <input type={showPass?'text':'password'} placeholder="Tu contraseña" value={pass} onChange={e => setPass(e.target.value)} style={{ paddingRight:40 }} onKeyDown={e => e.key==='Enter' && handleLogin()} />
            <i className={`ti ${showPass?'ti-eye-off':'ti-eye'}`} style={{ position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',color:'var(--text2)',cursor:'pointer',fontSize:16 }} onClick={() => setShowPass(!showPass)} />
          </div>
        </div>
        <div style={{ textAlign:'right',fontSize:12,color:'var(--purple-lt)',cursor:'pointer',marginBottom:14 }} onClick={() => setShowForgot(true)}>¿Olvidaste tu contraseña?</div>
        <button className="btn btn-primary btn-full" onClick={handleLogin} disabled={loading}>{loading ? 'Ingresando...' : 'Ingresar →'}</button>
        <div className="divider-text"><span>o ingresá con</span></div>
        <div className="grid-2" style={{ marginBottom:14 }}>
          <button
            style={{ background:'var(--bg2)',border:'0.5px solid var(--border)',borderRadius:'var(--radius-sm)',padding:'10px',fontSize:13,color:'var(--text)',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:7,fontFamily:'var(--font-body)' }}
            onClick={async () => {
              await supabase.auth.signInWithOAuth({
                provider: 'google',
                options: { redirectTo: window.location.origin }
              });
            }}
          >
            <i className="ti ti-brand-google" style={{ fontSize:17 }} /> Google
          </button>
          <button
            style={{ background:'var(--bg2)',border:'0.5px solid var(--border)',borderRadius:'var(--radius-sm)',padding:'10px',fontSize:13,color:'var(--text2)',cursor:'not-allowed',display:'flex',alignItems:'center',justifyContent:'center',gap:7,fontFamily:'var(--font-body)',opacity:0.5 }}
            title="Próximamente"
          >
            <i className="ti ti-brand-instagram" style={{ fontSize:17 }} /> Instagram
          </button>
        </div>
        <div style={{ textAlign:'center',fontSize:13,color:'var(--text2)' }}>
          ¿No tenés cuenta? <span style={{ color:'var(--purple-lt)',cursor:'pointer',fontWeight:500 }} onClick={() => onNav('register')}>Registrate gratis</span>
        </div>
      </div>
    </div>
  );
}

// ─── REGISTER ─────────────────────────────────────────────────────────────────
function Register({ onNav, onLogin, initialRole }) {
  const [role, setRole] = useState(initialRole || 'marca');
  const [selectedNiches, setSelectedNiches] = useState([]);
  const [activeServices, setActiveServices] = useState(['Historia','Publicación','Reel']);
  const [precios, setPrecios] = useState({});
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [nombre, setNombre] = useState('');
  const [instagram, setInstagram] = useState('');
  const [seguidores, setSeguidores] = useState('');
  const [zona, setZona] = useState('');
  const [bio, setBio] = useState('');
  const [fotoPreview, setFotoPreview] = useState(null);
  const [nombreMarca, setNombreMarca] = useState('');
  const [rubro, setRubro] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [registroExitoso, setRegistroExitoso] = useState(false);

  const toggleNiche = n => setSelectedNiches(prev => prev.includes(n) ? prev.filter(x=>x!==n) : [...prev,n]);
  const toggleService = s => setActiveServices(prev => prev.includes(s) ? prev.filter(x=>x!==s) : [...prev,s]);

  const handleFotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setFotoPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleRegister = async () => {
    if (!email || !pass || !nombre) { setError('Completá todos los campos obligatorios.'); return; }
    if (pass.length < 6) { setError('La contraseña debe tener al menos 6 caracteres.'); return; }

    setError('');
    setLoading(true);

    const { data, error: authError } = await supabase.auth.signUp({ email, password: pass });

    if (authError) {
      setLoading(false);
      setError(authError.message.includes('already') ? 'Ese email ya está registrado.' : 'Error al crear la cuenta. Probá de nuevo.');
      return;
    }

    const userId = data.user.id;

    const { error: userError } = await supabase.from('usuarios').insert({
      id: userId, email, nombre, rol: role
    });

    if (userError) {
      setLoading(false);
      setError('Error guardando tu perfil. Probá de nuevo.');
      return;
    }

    if (role === 'influencer') {
      const { data: infData } = await supabase.from('influencers').insert({
        usuario_id: userId,
        handle: instagram,
        niche: selectedNiches.join(', '),
        seguidores: parseInt(seguidores) || 0,
        zona,
        bio,
        verificado: false
      }).select().single();

      if (infData) {
        const serviciosARows = activeServices.map(s => ({
          influencer_id: infData.id,
          tipo: s,
          precio: parseFloat(precios[s]?.monto) || 0,
          moneda: precios[s]?.moneda || 'USD'
        }));
        if (serviciosARows.length) await supabase.from('servicios').insert(serviciosARows);
      }
    } else {
      await supabase.from('marcas').insert({
        usuario_id: userId,
        nombre_marca: nombreMarca || nombre,
        rubro,
        zona
      });
    }

    setLoading(false);

    // Si Supabase requiere confirmación de email, no hay sesión activa todavía
    if (!data.session) {
      setRegistroExitoso(true);
      return;
    }

    onLogin({ id: userId, role, email, name: nombre });
  };

  if (registroExitoso) {
    return (
      <div style={{ maxWidth:420, margin:'0 auto' }}>
        <div className="card" style={{ textAlign:'center', padding:'2.5rem 1.5rem', marginTop:40 }}>
          <div style={{ width:60,height:60,borderRadius:'50%',background:'var(--purple-bg)',color:'var(--purple-lt)',fontSize:26,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 1.2rem' }}>
            <i className="ti ti-mail" />
          </div>
          <div style={{ fontSize:18,fontWeight:500,marginBottom:8 }}>Confirmá tu email</div>
          <div style={{ fontSize:13,color:'var(--text2)',lineHeight:1.6,marginBottom:6 }}>
            Te enviamos un link de confirmación a:
          </div>
          <div style={{ fontSize:14,fontWeight:500,color:'var(--purple-lt)',marginBottom:18 }}>{email}</div>
          <div style={{ fontSize:13,color:'var(--text2)',lineHeight:1.6,marginBottom:22 }}>
            Abrí el correo y tocá el link para activar tu cuenta. Si no lo ves, revisá la carpeta de spam.
          </div>
          <button className="btn btn-outline btn-full" onClick={() => onNav('login')}>Ya confirmé, iniciar sesión →</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth:480, margin:'0 auto' }}>
      <div style={{ textAlign:'center',fontFamily:'var(--font-display)',fontSize:20,color:'var(--text2)',letterSpacing:'0.18em',padding:'20px 0 10px',textTransform:'uppercase' }}>
        <span style={{ color:'var(--purple-lt)',fontStyle:'italic' }}>Io</span> Sono
      </div>
      <div className="toggle-bar">
        <button className={`toggle-btn ${role==='marca'?'active':''}`} onClick={() => setRole('marca')}><i className="ti ti-building-store" /> Soy marca</button>
        <button className={`toggle-btn ${role==='influencer'?'active':''}`} onClick={() => setRole('influencer')}><i className="ti ti-camera" /> Soy influencer</button>
      </div>
      <div className="card">
        {error && (
          <div style={{ background:'var(--red-bg)',border:'0.5px solid rgba(226,75,74,0.3)',borderRadius:'var(--radius-sm)',padding:'10px 14px',fontSize:13,color:'var(--red)',marginBottom:14,display:'flex',gap:8,alignItems:'center' }}>
            <i className="ti ti-alert-circle" /> {error}
          </div>
        )}
        {role === 'marca' ? (
          <>
            <div style={{ fontSize:18,fontWeight:500,marginBottom:4 }}>Creá tu cuenta de marca</div>
            <div style={{ fontSize:13,color:'var(--text2)',marginBottom:20 }}>Encontrá al influencer ideal para tu negocio.</div>
            <div className="field"><label>Nombre completo *</label><input placeholder="Ej: Martina García" value={nombre} onChange={e => setNombre(e.target.value)} /></div>
            <div className="field"><label>Email *</label><input type="email" placeholder="hola@tumarca.com" value={email} onChange={e => setEmail(e.target.value)} /></div>
            <div className="field-row">
              <div className="field"><label>Contraseña *</label><input type="password" placeholder="Mínimo 6 caracteres" value={pass} onChange={e => setPass(e.target.value)} /></div>
              <div className="field"><label>Repetir</label><input type="password" placeholder="Repetir" /></div>
            </div>
            <div className="divider" />
            <div className="card-title">Datos de tu negocio</div>
            <div className="field"><label>Nombre de la marca o empresa</label><input placeholder="Ej: Tienda Nómade" value={nombreMarca} onChange={e => setNombreMarca(e.target.value)} /></div>
            <div className="field-row">
              <div className="field"><label>Rubro</label><select value={rubro} onChange={e => setRubro(e.target.value)}>{NICHES.map(n=><option key={n}>{n}</option>)}</select></div>
              <div className="field"><label>Zona</label><select value={zona} onChange={e => setZona(e.target.value)}>{ZONES.map(z=><option key={z}>{z}</option>)}</select></div>
            </div>
            <div className="field"><label>Instagram o web (opcional)</label><input placeholder="@tumarca o www.tumarca.com" value={instagram} onChange={e => setInstagram(e.target.value)} /></div>
          </>
        ) : (
          <>
            <div style={{ fontSize:18,fontWeight:500,marginBottom:4 }}>Creá tu perfil de influencer</div>
            <div style={{ fontSize:13,color:'var(--text2)',marginBottom:20 }}>Mostrá lo que valés y empezá a cobrar.</div>

            <div className="card-title">Foto de perfil</div>
            <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:16 }}>
              <label style={{ width:64, height:64, borderRadius:'50%', background:'var(--bg2)', border:'1px dashed var(--border)', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', flexShrink:0, overflow:'hidden' }}>
                {fotoPreview
                  ? <img src={fotoPreview} alt="Foto de perfil" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                  : <i className="ti ti-camera-plus" style={{ fontSize:22, color:'var(--text2)' }} />}
                <input type="file" accept="image/*" onChange={handleFotoChange} style={{ display:'none' }} />
              </label>
              <div style={{ fontSize:12, color:'var(--text2)', lineHeight:1.5 }}>Subí una foto clara de tu cara o tu logo. Esto es lo primero que ven las marcas.</div>
            </div>

            <div className="field"><label>Nombre completo *</label><input placeholder="Tu nombre real" value={nombre} onChange={e => setNombre(e.target.value)} /></div>
            <div className="field"><label>Email *</label><input type="email" placeholder="hola@vos.com" value={email} onChange={e => setEmail(e.target.value)} /></div>
            <div className="field-row">
              <div className="field"><label>Contraseña *</label><input type="password" placeholder="Mínimo 6 caracteres" value={pass} onChange={e => setPass(e.target.value)} /></div>
              <div className="field"><label>Repetir</label><input type="password" placeholder="Repetir" /></div>
            </div>
            <div className="divider" />
            <div className="card-title">Tu perfil público</div>
            <div className="field"><label>Usuario de Instagram *</label><input placeholder="@tuusuario" value={instagram} onChange={e => setInstagram(e.target.value)} /></div>
            <div className="field-row">
              <div className="field"><label>Seguidores *</label><input type="number" placeholder="Ej: 28000" value={seguidores} onChange={e => setSeguidores(e.target.value)} /></div>
              <div className="field"><label>Zona</label><select value={zona} onChange={e => setZona(e.target.value)}>{ZONES.map(z=><option key={z}>{z}</option>)}</select></div>
            </div>
            <div className="field"><label>Bio corta</label><textarea placeholder="Contá quién sos y qué contenido hacés..." value={bio} onChange={e => setBio(e.target.value)} /></div>
            <div className="card-title" style={{ marginTop:4 }}>Nicho / categoría</div>
            <div className="tags-wrap">
              {NICHES.map(n => <span key={n} className={`tag ${selectedNiches.includes(n)?'on':''}`} onClick={() => toggleNiche(n)}>{n}</span>)}
            </div>
            <div className="divider" />
            <div className="card-title">Tus servicios</div>
            <div className="grid-2" style={{ marginBottom:12 }}>
              {SERVICES_LIST.map(s => (
                <div key={s} className={`service-opt ${activeServices.includes(s)?'selected':''}`} onClick={() => toggleService(s)}>
                  <span style={{ fontSize:13 }}>{s}</span>
                  <span style={{ fontSize:11,color:activeServices.includes(s)?'var(--purple-lt)':'var(--text2)' }}>{activeServices.includes(s)?'✓':'+'}</span>
                </div>
              ))}
            </div>
            {activeServices.map(s => (
              <div key={s} style={{ display:'grid',gridTemplateColumns:'auto 1fr 80px',gap:8,alignItems:'center',marginBottom:8 }}>
                <span style={{ fontSize:13,color:'var(--text2)',minWidth:80 }}>{s}</span>
                <input
                  type="number"
                  placeholder="Precio"
                  value={precios[s]?.monto || ''}
                  onChange={e => setPrecios(prev => ({ ...prev, [s]: { ...prev[s], monto: e.target.value } }))}
                  style={{ background:'var(--bg2)',border:'0.5px solid var(--border)',borderRadius:'var(--radius-sm)',padding:'8px 10px',fontSize:13,color:'var(--text)',fontFamily:'var(--font-body)' }}
                />
                <select
                  value={precios[s]?.moneda || 'USD'}
                  onChange={e => setPrecios(prev => ({ ...prev, [s]: { ...prev[s], moneda: e.target.value } }))}
                  style={{ background:'var(--bg2)',border:'0.5px solid var(--border)',borderRadius:'var(--radius-sm)',padding:'8px 8px',fontSize:13,color:'var(--text)',fontFamily:'var(--font-body)' }}
                >
                  <option>ARS</option><option>USD</option>
                </select>
              </div>
            ))}
          </>
        )}
        <button className="btn btn-primary btn-full" style={{ marginTop:16 }} onClick={handleRegister} disabled={loading}>
          {loading ? 'Creando...' : `Crear ${role==='marca'?'cuenta':'perfil'} ↗`}
        </button>
        <div className="divider-text" style={{ marginTop:12 }}><span>o registrate con</span></div>
        <button
          className="btn btn-full"
          style={{ background:'var(--bg2)', border:'0.5px solid var(--border)', color:'var(--text)', display:'flex', alignItems:'center', justifyContent:'center', gap:8, fontSize:14, borderRadius:'var(--radius)' }}
          onClick={async () => {
            await supabase.auth.signInWithOAuth({
              provider: 'google',
              options: { redirectTo: window.location.origin }
            });
          }}
        >
          <i className="ti ti-brand-google" style={{ fontSize:18 }} /> Continuar con Google
        </button>
        <div style={{ textAlign:'center',fontSize:12,color:'var(--text2)',marginTop:12 }}>
          ¿Ya tenés cuenta? <span style={{ color:'var(--purple-lt)',cursor:'pointer' }} onClick={() => onNav('login')}>Iniciá sesión</span>
        </div>
      </div>
    </div>
  );
}

// ─── BUSCADOR (solo para marcas logueadas) ────────────────────────────────────
function Buscador({ onNav }) {
  const [tab, setTab] = useState('perfil');
  const [selInf, setSelInf] = useState(null);

  if (selInf) return <Profile inf={selInf} onBack={() => setSelInf(null)} onNav={onNav} />;

  return (
    <div>
      <div style={{ fontSize:18,fontWeight:500,marginBottom:4,paddingTop:16 }}>Buscá influencers</div>
      <div style={{ fontSize:13,color:'var(--text2)',marginBottom:16 }}>Encontrá al influencer ideal para tu campaña.</div>
      <div className="grid-2" style={{ marginBottom:12 }}>
        <select style={{ background:'var(--bg2)',border:'0.5px solid var(--border)',borderRadius:'var(--radius-sm)',padding:'10px 12px',color:'var(--text)',fontSize:13,fontFamily:'var(--font-body)' }}>
          <option>Todos los nichos</option>{NICHES.map(n=><option key={n}>{n}</option>)}
        </select>
        <select style={{ background:'var(--bg2)',border:'0.5px solid var(--border)',borderRadius:'var(--radius-sm)',padding:'10px 12px',color:'var(--text)',fontSize:13,fontFamily:'var(--font-body)' }}>
          <option>Todos los rangos</option><option>Micro · 1K–10K</option><option>Mid · 10K–100K</option><option>Macro · 100K–500K</option>
        </select>
      </div>
      {INFLUENCERS.map(inf => (
        <div key={inf.id} className="inf-card" style={{ marginBottom:10 }} onClick={() => setSelInf(inf)}>
          <div style={{ display:'flex',gap:12,alignItems:'center',marginBottom:10 }}>
            <AvatarEl initials={inf.initials} color={inf.color} textColor={inf.textColor} size="md" />
            <div style={{ flex:1 }}>
              <div style={{ fontSize:14,fontWeight:500 }}>{inf.name}</div>
              <div style={{ fontSize:12,color:'var(--text2)' }}>{inf.handle} · {inf.zone}</div>
            </div>
            <span className="pill pill-purple" style={{ fontSize:10 }}>{inf.niche}</span>
          </div>
          <div style={{ display:'flex',gap:16,marginBottom:10 }}>
            <div style={{ fontSize:12,color:'var(--text2)' }}><strong style={{color:'var(--text)'}}>{inf.followers}</strong> seg.</div>
            <div style={{ fontSize:12,color:'var(--text2)' }}><strong style={{color:'var(--text)'}}>{inf.eng}</strong> eng.</div>
            <div style={{ fontSize:12,color:'var(--text2)' }}><strong style={{color:'var(--amber)'}}>{inf.rating} ★</strong></div>
          </div>
          <div style={{ display:'flex',gap:6,flexWrap:'wrap' }}>
            {inf.services.slice(0,3).map(s => (
              <div key={s.name} style={{ background:'var(--bg2)',borderRadius:'var(--radius-sm)',padding:'5px 10px',fontSize:11,display:'flex',gap:6 }}>
                <span style={{color:'var(--text2)'}}>{s.name}</span><span style={{fontWeight:500}}>{s.price}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

// ─── PERFIL INFLUENCER ────────────────────────────────────────────────────────
function Profile({ inf, onBack, onNav }) {
  const [tab, setTab] = useState('servicios');
  return (
    <div>
      <button onClick={onBack} style={{ background:'transparent',border:'none',color:'var(--purple-lt)',cursor:'pointer',fontSize:13,display:'flex',alignItems:'center',gap:5,padding:'16px 0 8px' }}>
        <i className="ti ti-arrow-left" /> Volver al buscador
      </button>
      <div className="hero">
        <div className="hero-inner">
          <div style={{ display:'flex',gap:14,alignItems:'flex-start',flexWrap:'wrap' }}>
            <AvatarEl initials={inf.initials} color={inf.color} textColor={inf.textColor} size="lg" />
            <div style={{ flex:1 }}>
              <div style={{ fontSize:22,fontWeight:500,marginBottom:3 }}>{inf.name} <span style={{ fontSize:11,color:'var(--green)',marginLeft:8 }}><i className="ti ti-rosette-discount-check" /> verificada</span></div>
              <div style={{ fontSize:13,color:'var(--text2)',marginBottom:10 }}>{inf.handle} · Instagram</div>
              <div style={{ display:'flex',flexWrap:'wrap',gap:6,marginBottom:10 }}>
                <span className="pill pill-purple">{inf.niche}</span>
                <span className="pill pill-green">{inf.followers} seg.</span>
                <span className="pill pill-gray">{inf.zone}</span>
              </div>
            </div>
          </div>
          <div className="stats-row" style={{ marginTop:16 }}>
            <div className="stat-cell"><div className="stat-num">{inf.followers}</div><div className="stat-lbl">Seg.</div></div>
            <div className="stat-cell"><div className="stat-num">{inf.eng}</div><div className="stat-lbl">Eng.</div></div>
            <div className="stat-cell"><div className="stat-num">{inf.campaigns}</div><div className="stat-lbl">Campañas</div></div>
            <div className="stat-cell"><div className="stat-num">{inf.rating} ★</div><div className="stat-lbl">Rating</div></div>
          </div>
        </div>
      </div>
      <div className="toggle-bar">
        {['servicios','portfolio','reseñas'].map(t => (
          <button key={t} className={`toggle-btn ${tab===t?'active':''}`} onClick={() => setTab(t)} style={{ textTransform:'capitalize' }}>{t}</button>
        ))}
      </div>
      {tab === 'servicios' && (
        <div className="card">
          <div className="card-title">Servicios y aranceles</div>
          {inf.services.map(s => (
            <div key={s.name} className="row-item">
              <i className={`ti ${s.icon}`} style={{ fontSize:18,color:'var(--purple-lt)' }} />
              <div className="row-info"><div className="row-name">{s.name}</div></div>
              <div style={{ display:'flex',alignItems:'center',gap:10 }}>
                <span style={{ fontSize:14,fontWeight:500 }}>{s.price}</span>
                <button className="btn btn-primary btn-sm" onClick={() => onNav('hire', { inf, service:s })}>Contratar</button>
              </div>
            </div>
          ))}
        </div>
      )}
      {tab === 'portfolio' && (
        <div className="card">
          <div className="card-title">Portfolio con métricas</div>
          <div style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8 }}>
            {inf.portfolio.map((p,i) => (
              <div key={i} className="port-card">
                <div className="port-thumb" style={{ background:i===0?'#1a0f2e':i===1?'#0d1a2e':'#1a1208' }}>
                  <span style={{ fontSize:28 }}>{p.emoji}</span>
                  <span className="port-badge">{p.type}</span>
                  <span className="port-brand">{p.brand}</span>
                </div>
                <div className="port-metrics">
                  {[['reach','Alcance'],[' likes','Likes'],['comments','Com.'],['eng','Eng.']].map(([k,l]) => (
                    <div key={k} className="port-metric"><div className="port-metric-num">{p[k.trim()]}</div><div className="port-metric-lbl">{l}</div></div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {tab === 'reseñas' && (
        <div className="card">
          <div className="card-title">Reseñas de marcas</div>
          {[['Tienda Nómade','★★★★★','Muy profesional, entregó antes del plazo.','Reel'],['Studio Luce','★★★★★','Engagement increíble. Muy buena comunicación.','Historia'],['Glam BA','★★★★☆','Buen trabajo, cumplió en tiempo.','Publicación']].map(([brand,stars,text,svc]) => (
            <div key={brand} className="row-item" style={{ flexDirection:'column',alignItems:'flex-start',gap:4 }}>
              <div style={{ display:'flex',justifyContent:'space-between',width:'100%' }}>
                <span style={{ fontSize:13,fontWeight:500 }}>{brand}</span>
                <span style={{ color:'var(--amber)',fontSize:12 }}>{stars}</span>
              </div>
              <div style={{ fontSize:12,color:'var(--text2)',lineHeight:1.5 }}>{text}</div>
              <span style={{ fontSize:11,color:'var(--purple-lt)' }}>{svc}</span>
            </div>
          ))}
        </div>
      )}
      <div style={{ background:'var(--bg)',borderRadius:'var(--radius-lg)',padding:'16px 20px',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12 }}>
        <div style={{ fontSize:13,color:'var(--text2)' }}><strong style={{color:'var(--text)'}}>El pago queda retenido hasta que publique.</strong></div>
        <button className="btn btn-primary btn-sm" onClick={() => onNav('hire', { inf, service:inf.services[0] })}>Contratar ahora ↗</button>
      </div>
    </div>
  );
}

// ─── MI PERFIL INFLUENCER ─────────────────────────────────────────────────────
function Checkout({ data, onNav }) {
  const inf = data?.inf;
  const service = data?.service;
  const priceNum = service ? parseFloat((service.price||'').replace(/[^0-9.]/g,'')) || 0 : 0;
  const isUSD = service?.price?.includes('USD');
  const symbol = isUSD ? 'USD' : '$';

  const [metodo, setMetodo] = useState('transferencia');
  const [cuotas, setCuotas] = useState(1);
  const [confirmado, setConfirmado] = useState(false);

  // Comisión de Io Sono: 5% a la marca + 3% al influencer (ya implícito en el neto del influencer)
  const comisionIoSono = priceNum * 0.05;

  // Recargo de tarjeta: solo si paga con tarjeta. 1 pago ~6.5% (costo real de MP), en cuotas se suma interés por cuota.
  const RECARGO_1_PAGO = 0.065;
  const INTERES_POR_CUOTA = 0.07; // aprox 7% adicional por cada cuota más allá de la primera

  let recargoTarjeta = 0;
  if (metodo === 'tarjeta') {
    recargoTarjeta = priceNum * RECARGO_1_PAGO;
    if (cuotas > 1) recargoTarjeta += priceNum * INTERES_POR_CUOTA * (cuotas - 1);
  }

  const totalAPagar = priceNum + comisionIoSono + recargoTarjeta;
  const montoPorCuota = totalAPagar / cuotas;

  if (!inf || !service) {
    return (
      <div className="card" style={{ marginTop:16 }}>
        <div className="card-title">No hay ningún servicio seleccionado</div>
        <button className="btn btn-outline btn-full" onClick={() => onNav('buscador')}>Ir al buscador</button>
      </div>
    );
  }

  if (confirmado) {
    return (
      <div style={{ maxWidth:440, margin:'0 auto' }}>
        <div className="card" style={{ textAlign:'center', padding:'2rem 1rem' }}>
          <div style={{ width:60,height:60,borderRadius:'50%',background:'var(--green-bg)',color:'var(--green)',fontSize:26,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 1rem' }}>
            <i className="ti ti-shield-check" />
          </div>
          <div style={{ fontSize:18,fontWeight:500,marginBottom:6 }}>¡Pago retenido con éxito!</div>
          <div style={{ fontSize:13,color:'var(--text2)',lineHeight:1.6,maxWidth:320,margin:'0 auto 1.5rem' }}>
            Tu dinero está seguro. {inf.name} ya fue notificada y tiene plazo para publicar. El pago se libera recién cuando confirmés.
          </div>
          <button className="btn btn-primary btn-full" onClick={() => onNav('brand-panel')}>Ver mis campañas ↗</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth:440, margin:'0 auto' }}>
      <button onClick={() => onNav('buscador')} style={{ background:'transparent',border:'none',color:'var(--purple-lt)',cursor:'pointer',fontSize:13,display:'flex',alignItems:'center',gap:5,padding:'16px 0 8px' }}>
        <i className="ti ti-arrow-left" /> Volver
      </button>

      <div className="card">
        <div className="card-title">Resumen del servicio</div>
        <div style={{ display:'flex',gap:12,alignItems:'center',marginBottom:6 }}>
          <AvatarEl initials={inf.initials} color={inf.color} textColor={inf.textColor} size="md" />
          <div><div style={{ fontSize:14,fontWeight:500 }}>{inf.name}</div><div style={{ fontSize:12,color:'var(--text2)' }}>{service.name}</div></div>
        </div>
      </div>

      <div className="card">
        <div className="card-title">Elegí cómo pagar</div>
        <div className="grid-2" style={{ marginBottom:14 }}>
          <div className={`service-opt ${metodo==='transferencia'?'selected':''}`} onClick={() => { setMetodo('transferencia'); setCuotas(1); }} style={{ flexDirection:'column', alignItems:'flex-start', gap:4, padding:'12px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:6, width:'100%', justifyContent:'space-between' }}>
              <span style={{ fontSize:13, fontWeight:500 }}><i className="ti ti-building-bank" style={{ marginRight:6 }} />Transferencia</span>
            </div>
            <span className="pill pill-green" style={{ fontSize:10 }}>Sin recargo</span>
          </div>
          <div className={`service-opt ${metodo==='tarjeta'?'selected':''}`} onClick={() => setMetodo('tarjeta')} style={{ flexDirection:'column', alignItems:'flex-start', gap:4, padding:'12px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:6, width:'100%', justifyContent:'space-between' }}>
              <span style={{ fontSize:13, fontWeight:500 }}><i className="ti ti-credit-card" style={{ marginRight:6 }} />Tarjeta</span>
            </div>
            <span className="pill pill-amber" style={{ fontSize:10 }}>+ recargo</span>
          </div>
        </div>

        {metodo === 'transferencia' && (
          <div style={{ background:'var(--bg2)', borderRadius:'var(--radius-sm)', padding:'12px 14px', fontSize:13, color:'var(--text2)', lineHeight:1.6 }}>
            Vas a transferir al CVU de Io Sono. Sin comisión de pasarela — pagás el precio exacto del servicio + nuestra comisión.
          </div>
        )}

        {metodo === 'tarjeta' && (
          <>
            <div className="field"><label>Cuotas</label>
              <select value={cuotas} onChange={e => setCuotas(parseInt(e.target.value))}>
                <option value={1}>1 pago</option>
                <option value={3}>3 cuotas</option>
                <option value={6}>6 cuotas</option>
                <option value={12}>12 cuotas</option>
              </select>
            </div>
            <div style={{ background:'var(--amber-bg)', borderRadius:'var(--radius-sm)', padding:'10px 12px', fontSize:12, color:'var(--amber)', display:'flex', gap:6, alignItems:'flex-start', marginBottom:10 }}>
              <i className="ti ti-info-circle" style={{ flexShrink:0, marginTop:1 }} />
              <span>El costo de procesar con tarjeta ({cuotas===1 ? '~6.5%' : `interés de ${cuotas} cuotas`}) lo absorbés vos como comprador — ni la marca ni el influencer pierden nada de su parte.</span>
            </div>
            <div className="field"><label>Número de tarjeta</label><input placeholder="•••• •••• •••• ••••" /></div>
            <div className="field-row">
              <div className="field"><label>Vencimiento</label><input placeholder="MM/AA" /></div>
              <div className="field"><label>CVV</label><input placeholder="•••" /></div>
            </div>
          </>
        )}
      </div>

      <div className="card">
        <div className="card-title">Resumen del pago</div>
        <div style={{ background:'var(--bg2)', borderRadius:'var(--radius-sm)', padding:'14px' }}>
          <div style={{ display:'flex',justifyContent:'space-between',fontSize:13,color:'var(--text2)',marginBottom:8 }}>
            <span>Servicio ({service.name})</span><span style={{color:'var(--text)'}}>{symbol} {priceNum.toFixed(2)}</span>
          </div>
          <div style={{ display:'flex',justifyContent:'space-between',fontSize:13,color:'var(--text2)',marginBottom:8 }}>
            <span>Comisión Io Sono (5%)</span><span style={{color:'var(--text)'}}>{symbol} {comisionIoSono.toFixed(2)}</span>
          </div>
          {metodo === 'tarjeta' && (
            <div style={{ display:'flex',justifyContent:'space-between',fontSize:13,color:'var(--amber)',marginBottom:8 }}>
              <span>Recargo por tarjeta {cuotas>1 ? `(${cuotas} cuotas)` : '(1 pago)'}</span><span>{symbol} {recargoTarjeta.toFixed(2)}</span>
            </div>
          )}
          <div style={{ height:'0.5px', background:'var(--border)', margin:'8px 0' }} />
          <div style={{ display:'flex',justifyContent:'space-between',fontSize:15,fontWeight:500 }}>
            <span>Total</span><span style={{color:'var(--green)'}}>{symbol} {totalAPagar.toFixed(2)}</span>
          </div>
          {metodo === 'tarjeta' && cuotas > 1 && (
            <div style={{ fontSize:12, color:'var(--text2)', textAlign:'right', marginTop:4 }}>{cuotas} cuotas de {symbol} {montoPorCuota.toFixed(2)}</div>
          )}
        </div>
        <div className="escrow-note">
          <i className="ti ti-shield-check" />
          <span>El pago queda retenido. Se libera al influencer solo cuando confirmés que cumplió, o pasadas 24hs sin reclamo.</span>
        </div>
      </div>

      <button className="btn btn-primary btn-full" onClick={() => setConfirmado(true)}>
        Confirmar y pagar {symbol} {totalAPagar.toFixed(2)} ↗
      </button>
    </div>
  );
}

function MiPerfil({ user }) {
  const [tab, setTab] = useState('resumen');
  return (
    <div>
      <div className="hero" style={{ background:'#0a120a' }}>
        <div className="hero-inner" style={{ display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12 }}>
          <div>
            <div style={{ fontSize:18,fontWeight:500,color:'var(--text)',marginBottom:4 }}>Hola, {user.name} 👋</div>
            <div style={{ fontSize:13,color:'var(--text2)' }}>Tenés 2 trabajos activos y 1 oferta nueva.</div>
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:11,color:'var(--green)',textTransform:'uppercase',letterSpacing:'0.05em' }}>Disponible</div>
            <div style={{ fontSize:24,fontWeight:500,color:'var(--green)' }}>USD 315</div>
            <div style={{ fontSize:11,color:'var(--text2)' }}>+ USD 35 por liberar</div>
          </div>
        </div>
      </div>
      <div className="toggle-bar" style={{ overflowX:'auto' }}>
        {[['resumen','Resumen'],['trabajos','Trabajos'],['ingresos','Ingresos'],['ofertas','Ofertas']].map(([id,label]) => (
          <button key={id} className={`toggle-btn ${tab===id?'active':''}`} onClick={() => setTab(id)}>{label}</button>
        ))}
      </div>
      {tab === 'resumen' && (
        <div>
          <div className="grid-4" style={{ marginBottom:12 }}>
            {[['Trabajos','12','2 activos'],['Este mes','USD 155','+40%'],['Total','USD 980','acumulado'],['Rating','4.9 ★','11 reseñas']].map(([l,n,d]) => (
              <div key={l} style={{ background:'var(--bg2)',borderRadius:'var(--radius)',padding:'12px',textAlign:'center' }}>
                <div style={{ fontSize:10,color:'var(--text2)',marginBottom:4 }}>{l}</div>
                <div style={{ fontSize:16,fontWeight:500 }}>{n}</div>
                <div style={{ fontSize:11,color:'var(--green)',marginTop:3 }}>{d}</div>
              </div>
            ))}
          </div>
          <div className="card">
            <div className="card-title">Trabajos activos</div>
            {[{name:'Tienda Nómade · Historia',meta:'Publicaste · esperando confirmación',sc:'pill-amber',status:'18hs restantes',amount:'USD 35'},{name:'Viajes Latam · Reel',meta:'En progreso · vence en 3 días',sc:'pill-purple',status:'En progreso',amount:'USD 120'}].map(t => (
              <div key={t.name} className="row-item">
                <div className="row-info"><div className="row-name">{t.name}</div><div className="row-sub">{t.meta}</div></div>
                <div className="row-right"><span className={`pill ${t.sc}`}>{t.status}</span><div className="row-amount" style={{marginTop:4}}>{t.amount}</div></div>
              </div>
            ))}
          </div>
        </div>
      )}
      {tab === 'trabajos' && (
        <div className="card">
          <div className="card-title">Historial de trabajos</div>
          {[{name:'Tienda Nómade · Historia',date:'5 jun',sc:'pill-amber',status:'Esperando OK',amount:'USD 35'},{name:'Viajes Latam · Reel',date:'3 jun',sc:'pill-purple',status:'En progreso',amount:'USD 120'},{name:'Studio Luce · Post',date:'28 may',sc:'pill-green',status:'Pagado',amount:'USD 80'},{name:'Savia Skincare · Reel',date:'20 may',sc:'pill-green',status:'Pagado',amount:'USD 120'}].map(t => (
            <div key={t.name} className="row-item">
              <div className="row-info"><div className="row-name">{t.name}</div><div className="row-sub">{t.date}</div></div>
              <div className="row-right"><span className={`pill ${t.sc}`}>{t.status}</span><div className="row-amount" style={{marginTop:4}}>{t.amount}</div></div>
            </div>
          ))}
        </div>
      )}
      {tab === 'ingresos' && (
        <div>
          <div className="card">
            <div className="card-title">Historial de ingresos</div>
            {[{brand:'Tienda Nómade',svc:'Historia · por liberar',amount:'USD 35',c:'var(--amber)'},{brand:'Studio Luce',svc:'Post · pagado',amount:'USD 80',c:'var(--green)'},{brand:'Savia Skincare',svc:'Reel · pagado',amount:'USD 120',c:'var(--green)'}].map((i,idx) => (
              <div key={idx} className="row-item">
                <div className="row-info"><div className="row-name">{i.brand}</div><div className="row-sub">{i.svc}</div></div>
                <div style={{ fontSize:14,fontWeight:500,color:i.c }}>{i.amount}</div>
              </div>
            ))}
          </div>
          <div className="card">
            <div className="card-title">Retirar fondos</div>
            <div style={{ background:'var(--bg2)',borderRadius:'var(--radius-sm)',padding:'14px',marginBottom:12 }}>
              {[['Saldo disponible','USD 315.00','var(--green)'],['Por liberar','USD 35.00','var(--amber)']].map(([l,v,c]) => (
                <div key={l} style={{ display:'flex',justifyContent:'space-between',fontSize:13,marginBottom:8 }}>
                  <span style={{color:'var(--text2)'}}>{l}</span><span style={{fontWeight:500,color:c}}>{v}</span>
                </div>
              ))}
            </div>
            <button className="btn btn-green btn-full">Retirar USD 315 →</button>
          </div>
        </div>
      )}
      {tab === 'ofertas' && (
        <div>
          {[{brand:'Glam BA · Nueva oferta',amount:'USD 140',svc:'Reel · Fecha límite: 12 jun',border:'var(--purple)'},{brand:'Tienda Nómade · Recurrente',amount:'USD 35/mes',svc:'Historia mensual · 3 meses garantizados',border:'var(--green)'}].map(o => (
            <div key={o.brand} style={{ background:'var(--bg2)',borderRadius:'var(--radius-sm)',padding:'12px 14px',marginBottom:8,borderLeft:`3px solid ${o.border}` }}>
              <div style={{ display:'flex',justifyContent:'space-between',marginBottom:6 }}>
                <span style={{ fontSize:13,fontWeight:500 }}>{o.brand}</span>
                <span style={{ fontSize:14,fontWeight:500,color:'var(--green)' }}>{o.amount}</span>
              </div>
              <div style={{ fontSize:12,color:'var(--text2)',marginBottom:8 }}>{o.svc}</div>
              <div style={{ display:'flex',gap:6 }}>
                <button className="btn btn-green btn-sm">Aceptar ✓</button>
                <button className="btn btn-outline btn-sm">Declinar</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── PANEL MARCA ──────────────────────────────────────────────────────────────
function PanelMarca({ user, onNav }) {
  const [tab, setTab] = useState('campanas');
  return (
    <div>
      <div className="hero">
        <div className="hero-inner" style={{ display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12 }}>
          <div>
            <div style={{ fontSize:18,fontWeight:500,color:'var(--text)',marginBottom:4 }}>Hola, {user.name} 👋</div>
            <div style={{ fontSize:13,color:'var(--text2)' }}>Tenés 2 campañas activas.</div>
          </div>
          <button className="btn btn-primary btn-sm" onClick={() => onNav('buscador')}>
            <i className="ti ti-search" style={{ marginRight:5 }} /> Buscar influencers
          </button>
        </div>
      </div>
      <div style={{ display:'flex', gap:10, marginBottom:12 }}>
        <button className="btn btn-primary btn-full" onClick={() => onNav('buscador')}>+ Nueva campaña</button>
      </div>
      <div className="toggle-bar">
        {[['campanas','Mis campañas'],['metricas','Métricas'],['notifs','Alertas']].map(([id,label]) => (
          <button key={id} className={`toggle-btn ${tab===id?'active':''}`} onClick={() => setTab(id)}>{label}</button>
        ))}
      </div>
      {tab === 'campanas' && (
        <div className="card">
          <div className="card-title">Historial de campañas</div>
          {[{initials:'VL',color:'#2a1a4a',tc:'#a78bfa',name:'Vale López · Historia',date:'5 jun',sc:'pill-amber',status:'Esperando OK',amount:'USD 35'},{initials:'MG',color:'#0d2112',tc:'#4ade80',name:'Maxi González · Reel',date:'3 jun',sc:'pill-purple',status:'En progreso',amount:'USD 120'},{initials:'LV',color:'#1a1228',tc:'#a78bfa',name:'Lucía Viajes · Post',date:'28 may',sc:'pill-green',status:'Completada',amount:'USD 80'}].map(c => (
            <div key={c.name} className="row-item">
              <AvatarEl initials={c.initials} color={c.color} textColor={c.tc} size="sm" />
              <div className="row-info"><div className="row-name">{c.name}</div><div className="row-sub">{c.date}</div></div>
              <div className="row-right"><span className={`pill ${c.sc}`}>{c.status}</span><div className="row-amount" style={{marginTop:4}}>{c.amount}</div></div>
            </div>
          ))}
        </div>
      )}
      {tab === 'metricas' && (
        <div className="card">
          <div className="card-title">Rendimiento de campañas</div>
          {[['Alcance total','184.200 personas'],['Likes totales','11.300'],['Engagement promedio','5.8%'],['Invertido total','USD 610'],['Costo por 1000 alcanzados','USD 3.31']].map(([l,v]) => (
            <div key={l} className="row-item">
              <div className="row-info"><div className="row-name">{l}</div></div>
              <div style={{ fontSize:14,fontWeight:500 }}>{v}</div>
            </div>
          ))}
        </div>
      )}
      {tab === 'notifs' && (
        <div className="card">
          <div className="card-title">Notificaciones</div>
          {[{dot:'var(--purple)',text:<><strong>Vale López</strong> publicó la historia. Tenés 18hs para confirmar.</>,time:'Hace 5 horas'},{dot:'var(--purple)',text:<><strong>Maxi González</strong> envió el borrador para aprobación.</>,time:'Hace 2 horas'},{dot:'var(--border)',text:<><strong>Lucía Viajes</strong> completó el post. Pago liberado.</>,time:'Ayer'}].map((n,i) => (
            <div key={i} className="notif-item">
              <div className="notif-dot" style={{ background:n.dot }} />
              <div><div style={{ fontSize:13,lineHeight:1.5 }}>{n.text}</div><div style={{ fontSize:11,color:'var(--text2)',marginTop:3 }}>{n.time}</div></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── ADMIN ────────────────────────────────────────────────────────────────────
function AdminPanel() {
  const [tab, setTab] = useState('dashboard');
  return (
    <div>
      <div style={{ textAlign:'center',padding:'16px 0 8px' }}>
        <span style={{ fontFamily:'var(--font-display)',fontSize:14,color:'var(--text2)',letterSpacing:'0.18em',textTransform:'uppercase' }}>
          <span style={{color:'var(--purple-lt)'}}>IO SONO</span> · admin
        </span>
        <span style={{ fontSize:10,color:'var(--red)',background:'var(--red-bg)',padding:'2px 8px',borderRadius:100,marginLeft:6 }}>● live</span>
      </div>
      <div className="toggle-bar" style={{ overflowX:'auto',gap:2 }}>
        {[['dashboard','Dashboard'],['usuarios','Usuarios'],['campanas','Campañas'],['reclamos','Reclamos']].map(([id,label]) => (
          <button key={id} className={`toggle-btn ${tab===id?'active':''}`} onClick={() => setTab(id)} style={{ fontSize:11 }}>{label}
            {id==='reclamos' && <span style={{ background:'var(--red)',color:'#fff',fontSize:9,padding:'1px 5px',borderRadius:100,marginLeft:2 }}>3</span>}
          </button>
        ))}
      </div>
      {tab === 'dashboard' && (
        <div>
          <div className="grid-4" style={{ marginBottom:12 }}>
            {[['Usuarios','1.284','+48 esta semana'],['Campañas','87','+12 hoy'],['En escrow','USD 4.2K','+USD 380 hoy'],['Comisiones','USD 892','+23% vs ant']].map(([l,n,d]) => (
              <div key={l} style={{ background:'var(--bg2)',borderRadius:'var(--radius)',padding:'12px',textAlign:'center' }}>
                <div style={{ fontSize:10,color:'var(--text2)',marginBottom:4 }}>{l}</div>
                <div style={{ fontSize:18,fontWeight:500 }}>{n}</div>
                <div style={{ fontSize:10,color:'var(--green)',marginTop:3 }}>{d}</div>
              </div>
            ))}
          </div>
          <div className="card">
            <div className="card-title">Actividad reciente</div>
            {[['pill-green','Pago liberado','@valelopez → Tienda Nómade','USD 35','Hace 5 min'],['pill-purple','Nueva campaña','Glam BA → @maxifit','USD 99','Hace 18 min'],['pill-amber','Reclamo abierto','@sofibeauty → Studio Luce','USD 55','Hace 42 min'],['pill-red','Cuenta suspendida','@fake99','—','Hace 2h']].map(([sc,type,who,amount,time]) => (
              <div key={who} style={{ display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:'0.5px solid var(--border)' }}>
                <span className={`pill ${sc}`} style={{flexShrink:0,fontSize:10}}>{type}</span>
                <span style={{flex:1,fontSize:12,color:'var(--text2)'}}>{who}</span>
                <span style={{fontSize:12,fontWeight:500}}>{amount}</span>
                <span style={{fontSize:11,color:'var(--text2)'}}>{time}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {tab === 'usuarios' && (
        <div className="card">
          <div className="card-title">Influencers registrados</div>
          <table>
            <thead><tr><th>Influencer</th><th>Nicho</th><th>Seg.</th><th>Estado</th></tr></thead>
            <tbody>
              {[{initials:'VL',color:'#2a1a4a',tc:'#a78bfa',name:'Vale López',handle:'@valelopez',niche:'Moda',seg:'28K',sc:'pill-green',status:'Verificada'},{initials:'MG',color:'#0d2112',tc:'#4ade80',name:'Maxi González',handle:'@maxifit',niche:'Fitness',seg:'61K',sc:'pill-green',status:'Verificado'},{initials:'SR',color:'#1a0d14',tc:'#f472b6',name:'Sofi Ríos',handle:'@sofibeauty',niche:'Belleza',seg:'9.2K',sc:'pill-amber',status:'En revisión'}].map(u => (
                <tr key={u.handle}>
                  <td><div style={{display:'flex',gap:8,alignItems:'center'}}><AvatarEl initials={u.initials} color={u.color} textColor={u.tc} size="sm" /><div><div style={{fontSize:12,fontWeight:500}}>{u.name}</div><div style={{fontSize:11,color:'var(--text2)'}}>{u.handle}</div></div></div></td>
                  <td style={{fontSize:12,color:'var(--text2)'}}>{u.niche}</td>
                  <td style={{fontSize:12}}>{u.seg}</td>
                  <td><span className={`pill ${u.sc}`} style={{fontSize:10}}>{u.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {tab === 'campanas' && (
        <div className="card">
          <div className="card-title">Campañas activas</div>
          {[{from:'Tienda Nómade → @valelopez',svc:'Historia',amount:'USD 35',sc:'pill-amber',status:'Esperando OK'},{from:'Glam BA → @maxifit',svc:'Reel',amount:'USD 120',sc:'pill-purple',status:'En progreso'},{from:'Savia → @sofibeauty',svc:'Review',amount:'USD 55',sc:'pill-red',status:'En reclamo'}].map(c => (
            <div key={c.from} className="row-item">
              <div className="row-info"><div className="row-name" style={{fontSize:12}}>{c.from}</div><div className="row-sub">{c.svc}</div></div>
              <div className="row-right"><span className={`pill ${c.sc}`} style={{fontSize:10}}>{c.status}</span><div className="row-amount" style={{marginTop:4,fontSize:13}}>{c.amount}</div></div>
            </div>
          ))}
        </div>
      )}
      {tab === 'reclamos' && (
        <div>
          {[{title:'Savia Skincare vs @sofibeauty',meta:'No respetó restricciones · USD 55',sc:'pill-red',border:'var(--red)'},{title:'Studio Luce vs @luciamoda',meta:'Publicó antes del lanzamiento · USD 80',sc:'pill-amber',border:'var(--amber)'}].map(r => (
            <div key={r.title} style={{ background:'var(--bg2)',borderRadius:'var(--radius-sm)',padding:'12px 14px',marginBottom:8,borderLeft:`3px solid ${r.border}` }}>
              <div style={{ display:'flex',justifyContent:'space-between',marginBottom:6 }}>
                <span style={{fontSize:13,fontWeight:500}}>{r.title}</span>
                <span className={`pill ${r.sc}`} style={{fontSize:10}}>Urgente</span>
              </div>
              <div style={{ fontSize:12,color:'var(--text2)',marginBottom:8 }}>{r.meta}</div>
              <div style={{ display:'flex',gap:6 }}>
                <button className="btn btn-green btn-sm">Resolver ↗</button>
                <button style={{background:'transparent',border:'0.5px solid var(--border)',color:'var(--text2)',fontSize:11,padding:'4px 10px',borderRadius:'var(--radius-sm)',cursor:'pointer'}}>Ver campaña</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── APP SHELL ────────────────────────────────────────────────────────────────
export default function IoSono() {
  const [screen, setScreen] = useState('landing');
  const [screenData, setScreenData] = useState(null);
  const [user, setUser] = useState(null);
  const [checkingSession, setCheckingSession] = useState(true);
  const [resetPassword, setResetPassword] = useState(false);
  const [newPass, setNewPass] = useState('');
  const [newPassRepeat, setNewPassRepeat] = useState('');
  const [resetMsg, setResetMsg] = useState('');
  const [resetLoading, setResetLoading] = useState(false);

  useEffect(() => {
    const restoreSession = async () => {
      // Detectar si viene del link de recuperación de contraseña
      const hash = window.location.hash;
      if (hash.includes('type=recovery')) {
        setResetPassword(true);
        setCheckingSession(false);
        return;
      }

      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        const { data: perfil } = await supabase.from('usuarios').select('*').eq('id', session.user.id).single();
        if (perfil) {
          setUser({ id: session.user.id, role: perfil.rol, email: perfil.email, name: perfil.nombre });
          setScreen(perfil.rol === 'influencer' ? 'mi-perfil' : perfil.rol === 'admin' ? 'admin' : 'brand-panel');
        }
      }
      setCheckingSession(false);
    };
    restoreSession();

    // Escuchar eventos de auth (incluyendo PASSWORD_RECOVERY y SIGNED_IN de OAuth)
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setResetPassword(true);
        setCheckingSession(false);
      }
      if (event === 'SIGNED_IN' && session?.user) {
        // Verificar si ya tiene perfil, si no crearlo
        const { data: perfil } = await supabase.from('usuarios').select('*').eq('id', session.user.id).single();
        if (perfil) {
          setUser({ id: session.user.id, role: perfil.rol, email: perfil.email, name: perfil.nombre });
          setScreen(perfil.rol === 'influencer' ? 'mi-perfil' : perfil.rol === 'admin' ? 'admin' : 'brand-panel');
        } else {
          // Usuario nuevo via Google — crear perfil básico como marca
          const nombre = session.user.user_metadata?.full_name || session.user.email.split('@')[0];
          await supabase.from('usuarios').insert({
            id: session.user.id, email: session.user.email, nombre, rol: 'marca'
          });
          await supabase.from('marcas').insert({
            usuario_id: session.user.id, nombre_marca: nombre, rubro: '', zona: ''
          });
          setUser({ id: session.user.id, role: 'marca', email: session.user.email, name: nombre });
          setScreen('brand-panel');
        }
        setCheckingSession(false);
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleResetPassword = async () => {
    if (!newPass || newPass.length < 6) { setResetMsg('La contraseña debe tener al menos 6 caracteres.'); return; }
    if (newPass !== newPassRepeat) { setResetMsg('Las contraseñas no coinciden.'); return; }
    setResetLoading(true);
    const { error } = await supabase.auth.updateUser({ password: newPass });
    setResetLoading(false);
    if (error) { setResetMsg('Error al actualizar. Probá de nuevo.'); return; }
    setResetPassword(false);
    setScreen('login');
    window.location.hash = '';
  };

  const nav = (to, data=null) => { setScreen(to); setScreenData(data); window.scrollTo(0,0); };
  const handleLogin = (userData) => { setUser(userData); setScreen(userData.role==='influencer'?'mi-perfil':userData.role==='admin'?'admin':'brand-panel'); };
  const handleLogout = async () => { await supabase.auth.signOut(); setUser(null); setScreen('landing'); };

  const NAV_PUBLICA = [
    { id:'landing', icon:'ti-home', label:'Inicio' },
    { id:'login',   icon:'ti-user', label:'Ingresar' },
  ];

  const NAV_MARCA = [
    { id:'brand-panel', icon:'ti-layout-dashboard', label:'Mis campañas' },
    { id:'buscador',    icon:'ti-search',            label:'Buscar' },
  ];

  const NAV_INF = [
    { id:'mi-perfil', icon:'ti-user',     label:'Mi perfil' },
    { id:'buscador',  icon:'ti-search',   label:'Explorar' },
  ];

  const NAV_ADMIN = [
    { id:'admin', icon:'ti-layout-dashboard', label:'Admin' },
  ];

  const navItems = !user ? NAV_PUBLICA : user.role==='admin' ? NAV_ADMIN : user.role==='influencer' ? NAV_INF : NAV_MARCA;

  const renderScreen = () => {
    if (!user) {
      if (screen === 'login')    return <Login onNav={nav} onLogin={handleLogin} />;
      if (screen === 'register') return <Register onNav={nav} onLogin={handleLogin} initialRole={screenData?.initialRole} />;
      return <Landing onNav={nav} />;
    }
    if (user.role === 'admin')      return <AdminPanel />;
    if (screen === 'hire')          return <Checkout data={screenData} onNav={nav} />;
    if (user.role === 'influencer') return screen === 'buscador' ? <Buscador onNav={nav} /> : <MiPerfil user={user} />;
    // marca
    if (screen === 'buscador')    return <Buscador onNav={nav} />;
    if (screen === 'brand-panel') return <PanelMarca user={user} onNav={nav} />;
    return <PanelMarca user={user} onNav={nav} />;
  };

  if (resetPassword) {
    return (
      <>
        <style>{styles}</style>
        <div className="app" style={{ maxWidth:400 }}>
          <div className="hero" style={{ textAlign:'center', marginBottom:16, marginTop:24 }}>
            <div className="hero-inner">
              <div style={{ fontFamily:'var(--font-display)', fontSize:32, color:'var(--text)', letterSpacing:'0.1em', marginBottom:4 }}>
                <span style={{ color:'var(--purple-lt)', fontStyle:'italic' }}>Io</span> Sono
              </div>
            </div>
          </div>
          <div className="card">
            <div style={{ fontSize:18, fontWeight:500, marginBottom:6 }}>Nueva contraseña</div>
            <div style={{ fontSize:13, color:'var(--text2)', marginBottom:18, lineHeight:1.6 }}>
              Elegí una nueva contraseña para tu cuenta.
            </div>
            {resetMsg && (
              <div style={{ background:'var(--red-bg)', border:'0.5px solid rgba(226,75,74,0.3)', borderRadius:'var(--radius-sm)', padding:'10px 14px', fontSize:13, color:'var(--red)', marginBottom:14 }}>
                {resetMsg}
              </div>
            )}
            <div className="field">
              <label>Nueva contraseña</label>
              <input type="password" placeholder="Mínimo 6 caracteres" value={newPass} onChange={e => setNewPass(e.target.value)} />
            </div>
            <div className="field">
              <label>Repetir nueva contraseña</label>
              <input type="password" placeholder="Repetir" value={newPassRepeat} onChange={e => setNewPassRepeat(e.target.value)} onKeyDown={e => e.key==='Enter' && handleResetPassword()} />
            </div>
            <button className="btn btn-primary btn-full" onClick={handleResetPassword} disabled={resetLoading}>
              {resetLoading ? 'Guardando...' : 'Guardar nueva contraseña →'}
            </button>
          </div>
        </div>
      </>
    );
  }

  if (checkingSession) {
    return (
      <>
        <style>{styles}</style>
        <div className="app" style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh' }}>
          <div style={{ fontFamily:'var(--font-display)', fontSize:24, color:'var(--text2)', letterSpacing:'0.1em' }}>
            <span style={{ color:'var(--purple-lt)', fontStyle:'italic' }}>Io</span> Sono
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{styles}</style>
      <div className="app">
        {user && (
          <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 0 4px' }}>
            <span style={{ fontSize:12,color:'var(--text2)' }}>Hola, <strong style={{color:'var(--text)'}}>{user.name || user.email}</strong></span>
            <button onClick={handleLogout} style={{ background:'transparent',border:'none',color:'var(--text2)',fontSize:12,cursor:'pointer',display:'flex',alignItems:'center',gap:4 }}>
              <i className="ti ti-logout" style={{fontSize:14}} /> Salir
            </button>
          </div>
        )}
        {renderScreen()}
      </div>
      <nav className="nav">
        {navItems.map(item => (
          <button key={item.id} className={`nav-item ${screen===item.id?'active':''}`} onClick={() => nav(item.id)}>
            <i className={`ti ${item.icon}`} />{item.label}
          </button>
        ))}
      </nav>
    </>
  );
}
